export class dataEvento {
    public portale: string = null;
    public idEvento: number = null;
    public idDiretta: number = null;
    public nuovoStato: number = null;
    public requestIP: string = null;
    public frontEndApp: string = null;
    public clientTime: Date = null;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/data-evento.ts